import { extensions } from '@yola/ws-sdk';
import config from '../constants/config';

const getClosestPositioningElement = (element) => {
  const { imagePositioningSelector, imagePositioningRestrictedParentsSelector } =
    extensions.accessors.getExtensionSettings(config.slug);

  if (
    imagePositioningRestrictedParentsSelector &&
    element.closest(imagePositioningRestrictedParentsSelector)
  ) {
    return null;
  }

  return element.closest(imagePositioningSelector);
};

export default getClosestPositioningElement;
